(function(window, angular){'use strict';

var ngModule = angular.module('pp.widgets.dashboard-exited-loans', [
    'pp.widgets-templates',
    'pp.widgets.dashboard-exited-loans-table',
    'pp.services.dashboard'
]);

ngModule.component('ppDashboardExitedLoans', {
    templateUrl: 'widgets/_angular/dashboard-exited-loans/dashboard-exited-loans.tpl.html',
    bindings: {},
    controllerAs: 'vm',
    controller: ['$scope', 'dashboardService', function ($scope, dashboardService) {
        var vm = this;

        // -- initial state

        // -- util functions

        function init() {
            return dashboardService.getExitedLoans().then(function (data) {
                vm.data = data;
                vm.loadError = false;
            }, function () {
                vm.loadError = true;
            });
        }

        // -- api

        // -- scope bindings

        // -- main

        init().then(function () {
            vm.ready = true;
        });

    }]
});
})(window, window.angular);